import userReducer from "../ducks/user";

const reducers = {
    userReducer,
};

export default reducers;